/* eslint-disable @typescript-eslint/no-explicit-any */
// Single source of truth for the osprey-api BFF base URL.
//
// The Osprey UI talks ONLY to osprey-api — never to another API directly. Every
// client derives its base from here:
//   - ApiFetch        -> <base>            (rab data, finance, etc.)
//   - WatchmanFetch   -> <base>/iam        (osprey-api iam-proxy -> internal watchman)
//   - authApiClient   -> <base>/iam        (admin login via the iam-proxy)
//   - SynergyFetch    -> <base>            (osprey-api synergy-proxy: project-briefs/contact)
// osprey-api fans out internally, so the browser only ever needs one host.
//
// `BACKEND_LIVE_URL` (runtime env-config.js, per-env) is osprey-api's public host
// in deployed envs and http://localhost:3012/api/v1 locally. This is the ONLY
// backend URL the UI is configured with — there is intentionally no separate
// WATCHMAN_URL / SYNERGY_API_URL any more.
//
// ⚠️ Do NOT re-add direct watchman/synergy/rab base URLs here — route new calls
// through an osprey-api proxy instead, so the single-origin invariant holds.
export const getOspreyApiBaseUrl = (): string => {
  const runtime = (window as any).__RUNTIME_CONFIG__;
  if (runtime?.BACKEND_LIVE_URL) return runtime.BACKEND_LIVE_URL;
  if (import.meta.env.VITE_REACT_APP_BACKEND_LIVE_URL) return import.meta.env.VITE_REACT_APP_BACKEND_LIVE_URL;
  return 'http://localhost:3012/api/v1';
};
